<template>
  <div class="equimp-wrap">
    <div class="relaction-company">
      <el-button type="primary" size="small" @click="contactPerson">联系设备企业</el-button>
    </div>
    <div class="header-wrap">
      <div class="icon">
        <prod-icon :src="detailData.equipmentImages && detailData.equipmentImages[0].FileServerPath" :width="70" :height="70"></prod-icon>
      </div>
      <div class="des">
        <div style="font-size: 18px;font-weight: bold;">{{ detailData.equipmentName }}</div>
        <div>创建日期：{{ detailData.createDate && detailData.createDate.split(' ')[0] }}</div>
      </div>
    </div>
    <div class="descript">
      <div class="item-des">类型：<label v-html="detailData.intro"></label></div>
      <div class="item-des">工时费：{{ detailData.manHour }}</div>
      <div class="item-des">序号：{{ detailData.sortIndex }}</div>
      <div class="item-des">浏览次数：{{ detailData.viewNums }}</div>
      <div class="item-des">状态：{{ detailData.state == 6 ? '已上架' : '未上架' }}</div>
    </div>
    <div class="prod-size">产品选型：</div>
    <div class="simple-table">
      <div class="table-row header">
        <div class="cell">规格参数</div>
        <div class="cell">属性值</div>
      </div>
      <template v-if="tableData.length">
        <div class="table-row" v-for="item in tableData" :key="item.ItemID">
          <div class="cell">{{ item.specName }}</div>
          <div class="cell">{{ item.value }}</div>
        </div>
      </template>
      <div class="nodata" v-else>暂无选型</div>
    </div>
  </div>
</template>

<script>
import { ProductService } from '@/service/outsource'
import ProdIcon from "/@/components/icon/prod-icon.vue";
import { ChatService } from '@/service'
import { Category } from '@/libs'

export default {
  components: {
    ProdIcon
  },
  props: {
    id: {
      type: [Number, String]
    }
  },
  data () {
    return {
      detailData: {},
      tableData: []
    }
  },
  mounted(){
    this.getDetail()
  },
  methods: {
    // ------------------- 联系报价方
    contactPerson() {
      ChatService.StartRecent(Category.User, this.detailData.createUser)
    },

    async getDetail() {
      console.log(this.id)
      const res = await ProductService.getEquipmentInfo(this.id)
      this.detailData = res.data
      this.detailData.skuJsonParams = JSON.parse(this.detailData.skuJsonParams)
      // 组装产品选型为下面的格式
      // { specName: '型号', value: '文本' },
      // { specName: '型号1', value: '文本1' }
      this.tableData = new Array();
      for(let i in this.detailData.skuJsonParams.Columns) {
        if(this.detailData.skuJsonParams.Rows[0][i]) {
          this.tableData.push({
            specName: this.detailData.skuJsonParams.Columns[i].ItemName,
            value: this.detailData.skuJsonParams.Rows[0][i]
          })
        }
      }
    }
  }
}
</script>


<style scoped lang="less">
/deep/ .el-drawer__header {
  span {
    color: black;
  }
}
.equimp-wrap {
  padding: 0 20px 20px 20px;
  color: #484141;
  font-size: 14px;

  .relaction-company {
    position: absolute;
    top: 20px;
    right: 85px;
  }
  .nodata {
    line-height: 45px;
    text-align: center;
  }

  .prod-size {
    margin: 20px 0;
  }

  .simple-table {
    border: 1px solid #ddd;
    border-radius: 4px;
    overflow: hidden;
  }

  .table-row {
    display: flex;
    border-bottom: 1px solid #ddd;
  }

  .table-row:last-child {
    border-bottom: none;
  }

  .table-row.header {
    background-color: #f5f5f5;
    font-weight: bold;
  }

  .cell {
    flex: 1;
    padding: 12px;
    border-right: 1px solid #ddd;
  }

  .cell:last-child {
    border-right: none;
  }

  .header-wrap {
    display: flex;
    align-items: center;
    .icon {
      width: 70px;
      height: 70px;
      border-radius: 8px;
      margin-right: 15px;
    }
    .des {
      font-size: 16px;
      line-height: 28px;
      color: #333;
      & > div:last-child {
        margin-top: 5px;
        font-size: 14px;
        color: #484141;
      }
    }
  }
  .descript {
    .item-des {
      margin-top: 20px;
    }
  }
  .introduce {
    margin-top: 15px;
    line-height: 30px;
  }
}
</style>
